import React from 'react';
import './style.scss';

export enum IconSize {
  icon_xs = 'icon_xs',
  icon_s = 'icon_s',
  icon_m = 'icon_m',
  icon_l = 'icon_l',
  icon_xl = 'icon_xl',
}

export enum IconColor {
  primary = 'iconPrimary',
  white = 'iconWhite',
  blue = 'iconBlue',
  gray = 'iconGray',
  danger = 'iconDanger',
  warn = 'iconWarn',
}

type SvgIconProps = {
  icon: string;
  size?: IconSize;
  color?: IconColor;
};

export const SvgIcon = (props: SvgIconProps) => {
  const { icon, size, color } = props;
  return (
    <div className={`iconOuter ${size}`}>
      <img className={`iconInner ${color || ''}`} src={icon} alt="icon" />
    </div>
  );
};
